module.exports = __webpack_public_path__ + "static/grid_all.2f8ce24a.png";